const clippingOverflow = /^(auto|scroll|hidden|clip)$/u;

export const isFocusedEmbedVisible = (container: HTMLElement | undefined): boolean => {
	const frame = container?.ownerDocument.activeElement;
	const win = container?.ownerDocument.defaultView;
	if (!frame || !win || frame.tagName !== 'IFRAME' || !container?.contains(frame)) {
		return false;
	}

	const rect = frame.getBoundingClientRect();
	if (
		rect.width <= 0 ||
		rect.height <= 0 ||
		rect.top < 0 ||
		rect.left < 0 ||
		rect.bottom > win.innerHeight ||
		rect.right > win.innerWidth
	) {
		return false;
	}

	// The iframe can fit in the window but still be clipped by the editor's scroll container.
	for (let parent = frame.parentElement; parent; parent = parent.parentElement) {
		const style = win.getComputedStyle(parent);
		const clipsX = clippingOverflow.test(style.overflowX);
		const clipsY = clippingOverflow.test(style.overflowY);
		if (!clipsX && !clipsY) {
			continue;
		}
		const bounds = parent.getBoundingClientRect();
		const scaleX = parent.offsetWidth ? bounds.width / parent.offsetWidth : 1;
		const scaleY = parent.offsetHeight ? bounds.height / parent.offsetHeight : 1;
		const left = bounds.left + parent.clientLeft * scaleX;
		const top = bounds.top + parent.clientTop * scaleY;
		if (
			(clipsX && (rect.left < left || rect.right > left + parent.clientWidth * scaleX)) ||
			(clipsY && (rect.top < top || rect.bottom > top + parent.clientHeight * scaleY))
		) {
			return false;
		}
	}
	return true;
};
